import React, { Component } from 'react';
import './App.css';
import constants from './constants.js';
import {Button, PageHeader, ModalBody} from 'react-bootstrap';
import { PropagateLoader } from 'react-spinners';


class BuyButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ethValue: 0,
      transaction: null,
      error: null,
      loading: false, 
      confirm: false
    };
    this.buyPonzi = this.buyPonzi.bind(this);
    this.reset = this.reset.bind(this);
  }

  buyPonzi() {
    this.setState({loading: true});
    this.props.contractInstance.fund({value: constants.convertEthToWei(this.state.ethValue)}, (error, result) => {
        this.setState({transaction: result, loading: false, error: error});
      });
  }

  reset() {
    this.setState({loading: false, ethValue: 0, transaction: null, error: null, confirm: false});
  }

  render() {
    var mBody = 
    <div>
    <div className="modal-body">
      <p><b>Current Price per Token: {this.props.price} ETH</b></p>
      <p><i className="fa fa-warning" style={{color: '#ffbc19'}}></i> This price is not guaranteed, your ETH will be converted to PonziCoins at the current price when the transaction clears. The smallest amount of PonziCoin you can buy is 0.001. You will be refunded any ETH we were unable to convert to PonziCoins</p>
      <label htmlFor="eth-value" className="col-form-label">ETH to Convert</label>
      <input type="number" id="eth-value" className="form-control" placeholder="(e.g. 0.5)" onChange={(event) => {this.setState({ethValue: event.target.value});}} />
    </div>
    <div className="modal-footer">
      <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.reset}>Nope</button>
      <button type="button" className="btn btn-primary" onClick={() => {this.setState({confirm: true});}}>Yep</button>
    </div>
    </div>;

    if (this.state.confirm) {
      mBody =    <div>
      <div className="modal-body">
      <div class="alert alert-danger" role="alert">
    This is literally a pyramid scheme, be aware you are fairly likely to lose money. Are you sure you would like to perform this transaction?
    </div>
      
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.reset}>Nope</button>
        <button type="button" className="btn btn-primary" onClick={this.buyPonzi}>Yep</button>
      </div>
      </div> 
    }

    if (this.state.loading) {
      mBody =<div className="modal-body">
        Confirm the transaction on MetaMask!
      <div style={{margin: 'auto', width: 0, padding: 20}}>
      <PropagateLoader
          color={'#1888ff'} 
          loading={true} 
        />
      </div>
      <div className="modal-footer">
      <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.reset}>Cancel</button>
    </div>
  </div>;
        
    }
    if (this.state.error) {
    
      mBody=<div>
      <div className="modal-body">
        There was an error with the transaction :(

      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.reset}>Close</button>

        <button type="button" className="btn btn-primary" onClick={this.reset}>Try Again</button>
      </div>
      </div>;  
    }


    if (this.state.transaction) {
      mBody = <div>
      <div className="modal-body">
        You will soon be the proud owner of some PonziCoins!
        <br />
        <a target="_blank" href={"https://etherscan.io/tx/" + this.state.transaction}>View the transaction on Etherscan</a>
        <br />
        Also we need to be competitive with CryptoKitties' cuteness so heres a really nice dog:
        <img style={{width: '100%'}} src="/images/dog.jpeg" />
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.reset}>OK</button>
      </div>
      </div>; 
    }


    
    return (
      <div>
        <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModal" onClick={this.reset} disabled>
          Buy PonziCoins
        </button>

        <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Buy PonziCoins</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              {mBody}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BuyButton;



// WEBPACK FOOTER //
// ./src/BuyButton.js